export default {
  path: 'orders-invoices',
  name: 'subscription/orders-invoices',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "subscription-show-orders-invoices" */ './OrdersInvoices')
}
